import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { AmlineService } from '../amline.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { QuoteService } from '../../quote.service';
import { LocalStorageService } from 'ngx-webstorage';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SDTKService } from '../../sdtk/sdtk.service';
import { ExcessProtectService } from '../../excess-protect/excess.service';

const EXCESS_PROTECT_PRODUCT_ID = environment.EXCESS_PROTECT_ID;
const SADDLERY_TACK_PRODUCT_ID = environment.SADDLERY_TACK_PROTECT_ID;

@Component({
  selector: 'app-am-quote-view',
  templateUrl: './am-quote-view.component.html',
  styleUrls: ['./am-quote-view.component.css']
})
export class AmQuoteViewComponent implements OnInit {
  staticData;
  id = this.route.snapshot.params.quote_id;
  selectedIndex = 0;
  isAdmin = false;
  isStaff = false;
  isBroker = false;
  sdtkQuoteId: string = '';
  epQuoteId: string = '';
  sdtkQuoteDetails: any = null;
  epQuoteDetails: any = null;

  constructor(private as: AmlineService, private route: ActivatedRoute, private router: Router, private modalService: NgbModal,
    private quoteService: QuoteService, private sessionSt: LocalStorageService, private _snackBar: MatSnackBar,
    private sdtkService: SDTKService, private epService: ExcessProtectService) { }

  ngOnInit(): void {
    if (this.sessionSt.retrieve('is_admin')) {
      this.isAdmin = true;
    }
    if (this.sessionSt.retrieve('is_staff')) {
      this.isStaff = true;
    }
    if (this.sessionSt.retrieve('is_broker')) {
      this.isBroker = true;
    }
    this.getAccessToken();
    if (this.sessionSt.retrieve('is_broker')) {
      this.selectedIndex = 5;
    }
  }
  authDetails: string = '';
  getAccessToken() {
    let data = {
      'client_id': environment.AMLINE_CLIENT_ID,
      'client_secret': environment.AMLINE_CLIENT_SECRET,
      'grant_type': environment.AMLINE_GRANT_TYPE,
      'scope': environment.AMLINE_SCOPE,
    }
    this.as.getAccessToken(data)
      .subscribe(
        (response: any) => {
          if (response.access_token) {
            this.authDetails = response;
            this.getStaticData(response);
            this.getQuote(response);
          }
        },
        (error) => {
          ;
        }
      );
  }

  // GET STATIC DATA
  getStaticData(response) {
    this.as.getStaticData(response)
      .subscribe(
        (response: any) => {
          if (response.meta) {
            this.staticData = response.meta;
          }
        },
        (error) => {
          ;
        }
      );
  }
  // GET QUOTE DETAILS
  quoteDetails;
  fullQuote;
  getQuote(authDetails = '') {
    this.as.getAmlineData(this.route.snapshot.params.quote_id)
      .subscribe(
        (response: any) => {
          this.quoteDetails = response.result.quote_data.quote_versions[0].amlin_data.data.attributes;
          this.quoteDetails.insurance_status_id = response.result.quote_data.insurance_status_id;
          this.quoteDetails.id = response.result.quote_data.quote_versions[0].id;
          this.quoteDetails.company_id = response.result.quote_data.quote_versions[0].company_id;
          this.quoteDetails.company_name = response.result.quote_data.quote_versions[0].company_name;
          this.quoteDetails.is_send_email = response.result.quote_data.quote_versions[0].is_send_email;
          this.quoteDetails.type = response.result.quote_data.quote_versions[0].type;
          this.quoteDetails.broker_id = response.result.quote_data.quote_versions[0].broker_id;
          this.quoteDetails.notes = response.result.quote_data.quote_versions[0].notes;
          if (response.result.quote_data.quote_versions[0].financial_details) {
            this.quoteDetails.peliwica_fee = response.result.quote_data.quote_versions[0].financial_details.fees;
            this.quoteDetails.broker_commission = response.result.quote_data.quote_versions[0].financial_details.broker_commission;
            this.quoteDetails.broker_admin_fee = response.result.quote_data.quote_versions[0].financial_details.broker_admin_fee;
          } else {
            this.quoteDetails.peliwica_fee = 0;
            this.quoteDetails.broker_commission = 0;
            this.quoteDetails.broker_admin_fee = 0;
          }

          this.quoteDetails.email = response.result.quote_data.quote_versions[0].policy_holder?.email;
          this.quoteDetails.phone = response.result.quote_data.quote_versions[0].policy_holder?.phone;
          this.quoteDetails.is_email = response.result.quote_data.quote_versions[0].policy_holder?.is_email;
          this.quoteDetails.is_phone = response.result.quote_data.quote_versions[0].policy_holder?.is_phone;
          this.quoteDetails.sms = response.result.quote_data.quote_versions[0].policy_holder?.sms;
          this.quoteDetails.post = response.result.quote_data.quote_versions[0].policy_holder?.post;
          this.quoteDetails.affinity_partner = response.result.quote_data.quote_versions[0].affinity_partner;
          this.quoteDetails.transactional_date = response.result.quote_data.quote_versions[0].transactional_date;
          this.fullQuote = response.result.quote_data.quote_versions[0];
          this.quoteDetails.is_paid = response.result.quote_data.quote_versions[0].is_paid;
          this.quoteDetails.product_id = response.result.quote_data.quote_versions[0].product_id;
          this.quoteDetails.is_policy = response.result.quote_data.quote_versions[0].is_policy;
          // Fetch linked SDTK/EXP quotes via quote_group_id
          let quoteGroupId = response.result.quote_data.quote_versions[0].quote_group_id;
          if (quoteGroupId) {
            this.getLinkedQuotes(quoteGroupId);
          }
          this.getQuoteNotes();
        },
        (error) => {
          ;
        }
      );
  }

  // Issue Quote
  issueQuotePopup(issueQuoteModal) {
    this.modalService.open(issueQuoteModal, { centered: true });
  }
  issueQuote() {
    let data = {
      "amlin_quote_id": this.route.snapshot.params.quote_id
    };

    this.as.issueQuote(data)
      .subscribe(
        (res: any) => {
          if (res.success) {
            // Convert linked SDTK quote to policy if not already converted
            if (this.sdtkQuoteId && this.sdtkQuoteDetails && this.sdtkQuoteDetails.is_policy != 1) {
              this.sdtkService.issueQuote({ quote_id: this.sdtkQuoteId }).subscribe(
                (sdtkRes: any) => {},
                (error) => { console.error('Failed to convert SDTK to policy', error); }
              );
            }
            // Convert linked EP quote to policy if not already converted
            if (this.epQuoteId && this.epQuoteDetails && this.epQuoteDetails.is_policy != 1) {
              this.epService.issueQuote({ quote_id: this.epQuoteId }).subscribe(
                (epRes: any) => {},
                (error) => { console.error('Failed to convert EP to policy', error); }
              );
            }
            this.modalService.dismissAll();
            let id = this.route.snapshot.params.quote_id;
            this.router.navigateByUrl("/amline/policy/" + id);
          };
        });
  }


  // Refer Quote
  markAsReferred(referQuoteModal) {
    this.modalService.open(referQuoteModal, { centered: true });
  }

  
  refer_reason: string = '';
  refer_reason_error: boolean = false;

  onReferReasonChange(value: string): void {
    this.refer_reason_error = false;
    if (this.refer_reason == '') {
      this.refer_reason_error = true;
    }
 }

  referQuote() {
    this.refer_reason_error = false;
    if (this.refer_reason == '') {
      this.refer_reason_error = true;
      return;
    }
    let application = this.quoteDetails.application;
    let data = {
      data: {
        "type": this.fullQuote.amlin_data.data.type,
        "attributes": this.fullQuote.amlin_data.data.attributes.application,
        "id": this.fullQuote.amlin_id,
        "broker_id": this.fullQuote.broker_id,
        "company_id": this.fullQuote.company_id,
        "sequence_number": this.fullQuote.sequence_number,

        "policy_ref_number": this.fullQuote.policy_ref_number,
        "old_policy_id": this.fullQuote.old_policy_id,

        "quote_meta_id": this.fullQuote.quote_meta_id,
      },
      meta: {
        "refer": true,
        "refer_reason": this.refer_reason,
      },

    };


    this.as.saveQuote(data)
      .subscribe(
        (res: any) => {
          if (res.success) {
            this.getQuote();
            this._snackBar.open(res.message, '', {
              duration: 5000,
              panelClass: 'text-success'
            });
          } else {
            this._snackBar.open(res.message, '', {
              duration: 5000,
              panelClass: 'text-danger'
            });
          };
          this.modalService.dismissAll();
        });
  }

  /*
  * Get Notes
  */
  hasImportantNotes: boolean = false;
  totalImpNotes: number = 0;
  getQuoteNotes() {
    this.quoteService.getNotes(this.quoteDetails.id)
      .subscribe(
        (response: any) => {
          let impNotes = response.result.filter(x => x.is_important == 1);
          this.totalImpNotes = impNotes.length;
          if (impNotes.length > 0) {
            this.hasImportantNotes = true;
          }
        });
  }

  onhasImportantNotesChange(event) {
    this.hasImportantNotes = event;
    this.totalImpNotes = this.totalImpNotes + 1;
  }

  displayEmailView: boolean = false;
  displayNewEmailView: boolean = false;
  newEmailView() {
    this.displayNewEmailView = true;
  }

  email_id: string = '';
  getEmailView(email_id) {
    this.email_id = email_id;
    this.displayEmailView = true;
  }
  backToEmailsList() {
    this.displayEmailView = false;
    this.displayNewEmailView = false;
  }

  // Fetch linked SDTK and EXP quotes by quote_group_id
  getLinkedQuotes(quoteGroupId: string) {
    this.as.getQuotesByGroupId(quoteGroupId).subscribe(
      (res: any) => {
        if (res.success && res.result) {
          res.result.forEach((quote: any) => {
            if (quote.product_id === SADDLERY_TACK_PRODUCT_ID) {
              this.sdtkQuoteId = quote.quote_id;
              this.fetchSdtkQuoteDetails(quote.quote_id);
            }
            if (quote.product_id === EXCESS_PROTECT_PRODUCT_ID) {
              this.epQuoteId = quote.quote_id;
              this.fetchEpQuoteDetails(quote.quote_id);
            }
          });
        }
      },
      (error) => {
        console.error('Failed to load linked quotes', error);
      }
    );
  }

  // Fetch full SDTK quote details
  fetchSdtkQuoteDetails(quoteId: string) {
    this.sdtkService.getQuoteDetails(quoteId).subscribe(
      (response: any) => {
        if (response.result && response.result.quote_data) {
          let res_quote = response.result.quote_data.quote_versions.filter(x => x.id == quoteId);
          if (res_quote.length > 0) {
            this.sdtkQuoteDetails = res_quote[0];
          }
        }
      },
      (error) => {
        console.error('Failed to load SDTK quote details', error);
      }
    );
  }

  // Fetch full EP quote details
  fetchEpQuoteDetails(quoteId: string) {
    this.epService.getQuoteDetails(quoteId).subscribe(
      (response: any) => {
        if (response.result && response.result.quote_data) {
          let res_quote = response.result.quote_data.quote_versions.filter(x => x.id == quoteId);
          if (res_quote.length > 0) {
            this.epQuoteDetails = res_quote[0];
          }
        }
      },
      (error) => {
        console.error('Failed to load EP quote details', error);
      }
    );
  }
}
